import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

let filtersCopy = JSON.parse(JSON.stringify(filters))

let baseUrl = 'https://smsapi.mixitweb.com/api'

export default {
    namespaced: true,
    state: {
        sms: [],
        pagination: [],
        smsAuthorization: {},
        ...filtersCopy,
    },
    mutations: {
        setSms(state, sms) {
            state.sms = sms
        },
        setPagination(state, meta) {
            state.pagination = meta
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        async getSmsAuthorization({commit, state}) {
            if (Object.keys(state.smsAuthorization).length != 0) {
                return state.smsAuthorization;
            }
            let form = {
                items: [
                    'project_id',
                    'sms_token'
                ]
            }
            let req = await axios.post('site-info/get-multiple/item-with-name', form)
            let data = req.data.data
            data.forEach(item => {
                state.smsAuthorization[item['name']] = item['value']
            })

            return state.smsAuthorization;

        },
        async getSmsCharge({commit, state}) {
            let smsToken = state.smsAuthorization.sms_token
            let projectId = state.smsAuthorization.project_id
            let req = await axios.get(`${baseUrl}/sms/get-charge/project/${projectId}`, {
                headers: {
                    'Authorization': `Bearer ${smsToken}`
                }
            })
            return req
        },
        async getSms({commit, state}, page = 1) {
            await store.dispatch('Sms/getSmsAuthorization')

            let smsToken = state.smsAuthorization.sms_token
            let projectId = state.smsAuthorization.project_id

            const query = queryBuilder(state.filters)
            let req = axios.get(`${baseUrl}/sms/project/${projectId}?page=${page}&${query}`, {
                headers: {
                    'Authorization': `Bearer ${smsToken}`
                }
            })
            req.then(res => {
                const data = res.data.data;
                commit('setSms', data.data)
                commit('setPagination', data.meta)
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        async getSmsReport({commit, state}, form) {
            await store.dispatch('Sms/getSmsAuthorization')

            let smsToken = state.smsAuthorization.sms_token
            let projectId = state.smsAuthorization.project_id

            let req = await axios.get(`${baseUrl}/sms/report/${form.sms_id}/project/${projectId}`, {
                headers: {
                    'Authorization': `Bearer ${smsToken}`
                }
            })
            return req
        },
        async sendSms({commit, state}, form) {
            await store.dispatch('Sms/getSmsAuthorization')

            let smsToken = state.smsAuthorization.sms_token
            let projectId = state.smsAuthorization.project_id

            let req = await axios.post(`${baseUrl}/sms/send/project/${projectId}`, form, {
                headers: {
                    'Authorization': `Bearer ${smsToken}`
                }
            })
            return req
        },
    },
    getters: {
        getSms: state => state.sms,
        getPagination: state => state.pagination,
        getFilters: (state) => state.filters,
    }
}